// The demo league's line under the top bar (scenario O6, B-271).
//
// SAID BEFORE ANYTHING IS TAPPED. The demo league reads like any league and
// offers every action a league has, and the server refuses each of them; a
// refusal is a poor way to learn the rules of a place. So every page of it
// says, once, what it is and what it is not, the same at every detail level.

import { useLocation } from 'react-router-dom';
import { valueOf } from '@fsp/domain';
import { Icon } from '../kit/Icon';
import { isDemoLeague, useDemo } from '../data/demo';
import { leagueIdFromPath } from '../data/route';

export function DemoLine() {
  const { pathname } = useLocation();
  const { snapshot } = useDemo();
  const held = valueOf(snapshot)?.frozenAt;
  if (!isDemoLeague(leagueIdFromPath(pathname)) || held === undefined) return null;
  const day = new Intl.DateTimeFormat(undefined, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  }).format(new Date(held));
  return (
    <div className="fsp-demo-line" role="note">
      <Icon name="play" size="sm" />
      <span>
        A demo league, held still on {day}. Look at anything you like; nothing here can be changed.
      </span>
    </div>
  );
}
